import { UseFormReturnType } from '@mantine/form'
import { FormattedMessage } from 'react-intl'
import { IntegrationListItem } from '@/components/integrations/IntegrationListItem/IntegrationListItem'
import { EventDestination } from '@/types/deployment'
import { FormValues } from '../IntegrationSelection'
import { integrationConfig } from '../config'

type PlatformIntegrationProps = {
  form: UseFormReturnType<FormValues>
  disabled?: boolean
}

export const PlatformIntegration = ({
  form,
  disabled
}: PlatformIntegrationProps) => {
  const isSelected = form.getValues().integrations.platformEvents.isSelected

  return (
    <IntegrationListItem
      checkboxId="platform"
      isSelected={isSelected}
      disabled={disabled}
      title={
        <FormattedMessage
          id={integrationConfig[EventDestination.Visionplatform].name}
        />
      }
      description={
        <FormattedMessage
          id={integrationConfig[EventDestination.Visionplatform].description}
        />
      }
      logoSrc={integrationConfig[EventDestination.Visionplatform].logo}
      showDetails={isSelected}
      onChange={(value) => {
        form.setFieldValue('integrations.platformEvents.isSelected', value)
        form.clearErrors()
      }}
    />
  )
}
